import React from 'react';

const ManageProducts = () => {
    return (
        <div>
            <h2 className="text-danger">Manage Products</h2>
        </div>
    );
};

export default ManageProducts;